export const parseIntOrFloat = (num: string) => {
  if (num.includes(".")) {
    return parseFloat(num);
  }
  return parseInt(num);
};
